var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"513bade7394c933b01a84e4f87b264a36cf5d967"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["reformationbiblecollege-org@ligonier"]={id:"513bade7394c933b01a84e4f87b264a36cf5d967"};
      